// extracted by mini-css-extract-plugin
module.exports = {"subHeadingContainer":"styles_subHeadingContainer__aEGhu"};